<div class="production-db-content" dir="{{languageDir}}">
  <div class="content-top-box">
    <app-bread-crumb></app-bread-crumb>
    <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" template=" <img src='assets/images/spinner.gif' />"></ngx-spinner>
  </div>
  <mat-card>
    <div class="p-grid p-fluid">
      <div class="p-col-12 p-md-4 p-lg-3 p-xl-3">
        <mat-card-title>{{t('FiveSDashboard', '5S & Gemba Dashboard')}}</mat-card-title>
      </div>

      <div class="p-col-12 p-md-8 p-lg-3 p-xl-3"
        style="display: flex; justify-content: flex-end; flex: 0 0 auto; width: auto; max-width: none; margin-inline-start: auto;">
        <form [formGroup]="FiveSDashboardForm">
          <div class="headerForm d-flex">
            <!-- <mat-form-field appearence="fill" style="float: right;  margin-left: 10px;width: 18%">
              <mat-label>{{t('SelectGroup', 'SelectGroup')}}</mat-label>
              <mat-select formControlName="group" >
                <mat-select-filter [placeholder]="'Search Group'" [displayMember]="'TypeName'" [array]="groupList"
                  (filteredReturn)="groupFiltList = $event">
                </mat-select-filter>
                <mat-option *ngFor="let group of groupFiltList" [value]="group.TypeId">
                  {{ group.TypeName }}
                </mat-option>
              </mat-select>
              <mat-error>Group is required</mat-error>
            </mat-form-field> -->
            <!-- <mat-form-field appearence="fill" style="float: right;  margin-left: 10px;width: 18%">
              <mat-label>{{t('SelectPlant', 'SelectPlant')}} </mat-label>
              <mat-select formControlName="plant">
                <mat-select-filter [placeholder]="'Search Plant'" [displayMember]="'DeptDesc'" [array]="plantList"
                  (filteredReturn)="plantFiltList = $event">
                </mat-select-filter>
                <mat-option *ngFor="let plant of plantFiltList" [value]="plant.DeptId">
                  {{ plant.DeptDesc }}
                </mat-option>
              </mat-select>
            </mat-form-field> -->

            <!-- <mat-form-field
        appearance="fill"
        class="w-22"
        (click)="picker.open()"
        id="picker"
      >
        <mat-label>Date Range</mat-label>
        <mat-date-range-input [rangePicker]="picker">
          <input
            matStartDate
            formControlName="startDate"
            [placeholder]="t('FromDate', 'From Date')"
          />
          <input matEndDate formControlName="endDate" [placeholder]="t('ToDate', 'To Date')" />
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
      </mat-form-field> -->
            <!-- <div class="inputField">
        <nz-range-picker
          nzShowTime
          nzFormat="yyyy/MM/dd HH:mm:ss"
          (ngModelChange)="onChange($event)"
        ></nz-range-picker>
      </div> -->

            <div class="inputField">
              <nz-range-picker class="calender-input ml-10" style="width: 318px;" [nzInputReadOnly]="true"
                [nzShowTime]="{ nzFormat: 'HH:mm' }" nzFormat="dd-MM-yyyy HH:mm" [nzDisabledDate]="disabledDate"
                [nzLocale]="datePickerLocale"
                formControlName="datepicker" (ngModelChange)="onChange($event)"></nz-range-picker>
              <span class="floating-text">{{ t('DateRange', 'Date Range') }}</span>
            </div>
            <!--
      <button type="submit" class="search" tooltipPosition="top">
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19.3609 18.2168L14.6008 13.2662C15.8247 11.8113 16.4953 9.98069 16.4953 8.07499C16.4953 3.62251 12.8728 0 8.4203 0C3.96782 0 0.345306 3.62251 0.345306 8.07499C0.345306 12.5275 3.96782 16.15 8.4203 16.15C10.0918 16.15 11.6847 15.6458 13.0466 14.6888L17.8428 19.677C18.0432 19.8852 18.3129 20 18.6018 20C18.8753 20 19.1348 19.8957 19.3317 19.7061C19.7502 19.3034 19.7636 18.6357 19.3609 18.2168ZM8.4203 2.10652C11.7114 2.10652 14.3888 4.78391 14.3888 8.07499C14.3888 11.3661 11.7114 14.0435 8.4203 14.0435C5.12921 14.0435 2.45183 11.3661 2.45183 8.07499C2.45183 4.78391 5.12921 2.10652 8.4203 2.10652Z"
            fill="#10123D"
          />
        </svg>
      </button> -->
            <button mat-mini-fab mat-button color="primary" type="button" [pTooltip]="t('Search', 'Search')" tooltipPosition="top"
              style="margin-left: 10px;margin-top: 7px;" (click)="onSubmit()">
              <mat-icon>search</mat-icon>
            </button>
            <mat-card class="prev-btn" (click)="getFiveSDashboardDataPrev(2)">
              <b>{{ t('PeriodPrevious', 'Previous') }}</b>
            </mat-card>
            <mat-card class="current-btn" (click)="getFiveSDashboardDataPrev(1)">
              <b>{{ t('PeriodCurrent', 'Current') }}</b>
            </mat-card>

          </div>
        </form>
      </div>
    </div>
  </mat-card>

  <!-- chart -->
  <div class="divider">
    <div class="overall-gauge">
      <div id="overall-chart-gauge"></div>
    </div>
    <div class="gauge-bar-divider" id="gauge-bar-divider-id">
      <p class="sub-heading">{{t('SAreaWiseScore', '5S Area Wise Score')}}</p>
      <div class="gauge-divider" *ngFor="let item of values; let i = index">
        <div [id]="'chart-gauge-' + i" class="chart-gauge"></div>
      </div>
      <div class="bar-divider" style="box-shadow: unset !important">
        <div class="import_export">
          <button type="button" (click)="onBtnExportExcel()" class="export"
            *ngIf="isAccess | permissionChecker">{{t('DownloadExcelExportFile', 'Download Excel File')}}</button>
        </div>
        <div>
          <ag-grid-angular style="width: 90%; height:100%;margin: auto" class="ag-theme-alpine" id="eGrid"
            [rowData]="dataArray" [gridOptions]="gridOptions" [columnDefs]="columnDefs" [pagination]="true"
            [paginationPageSize]="5" [suppressRowTransform]="true" [masterDetail]="true"
            [detailCellRendererParams]="detailCellRendererParams" [detailRowAutoHeight]="true"
            (gridReady)="onGridReady($event)" [loadingOverlayComponent]="loadingOverlayComponent"></ag-grid-angular>
        </div>

      </div>

    </div>

    <div class="bar-divider">
      <div [chart]="ORPGraphData"></div>
      <div class="bar-divider" style="box-shadow: unset !important">
        <div class="import_export">
          <button type="button" (click)="onBtnExportGemba()" class="export"
            *ngIf="isAccess | permissionChecker">{{t('DownloadExcelExportFile', 'Download Excel File')}}</button>
        </div>
        <div style="display: flex; align-items: center; justify-content: center;">
          <ag-grid-angular style="width: 98%;height:560px;" class="ag-theme-alpine" id="eGrid" [rowData]="gembaRowData"
            [gridOptions]="gembaGridOptions" [columnDefs]="gembaColDef" [pagination]="true" [paginationPageSize]="10"
            (cellClicked)="cellClickedGemba($event)" (gridReady)="gembaOnGridReady($event)"
            [loadingOverlayComponent]="loadingOverlayComponent">
          </ag-grid-angular>
        </div>

      </div>
    </div>




  </div>

</div>
<!-- <button type="button" (click)="onBtnExportCSV()" style="margin-top: 30px;">{{t('Downloadexportfile', 'Downloadexportfile')}}</button> -->



<ng-template #5SPoup>
  <div mat-dialog-title class="mat-title">
    <div class="d-flex justify-content-between align-items-center">
      <h1 class="main-title"></h1>
      <button mat-mini-fab mat-button mat-dialog-close color="warn" [title]="t('Close', 'Close')">
        <i class="fa fa-times" style="color: #fff"></i>
      </button>
    </div>
    <div class="five-s-divider">
      <!-- <div
        *ngFor="let item of fiveSList; let i = index"
        [id]="'five-s-chart-' + i"
        class="chart-gauge-five-s"
      ></div> -->
      <div [chart]="chart" class="five-s"></div>
    </div>
  </div>
</ng-template>

<ng-template #CloseObservation>
  <div mat-dialog-title>
    <div class="d-flex justify-content-between align-items-center">
      <h2>{{ t('ActionDetail', 'Action Detail') }}</h2>
      <button mat-mini-fab mat-button mat-dialog-close color="warn" [title]="t('Close', 'Close')">
        <i class="fa fa-times" style="color: #fff"></i>
      </button>
    </div>
  </div>
  <mat-dialog-content style="overflow:unset">
    <form [formGroup]="closeGembaForm">
      <div class="content-row-wrap" style="justify-content: space-between">
        <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing"
          style="margin-left: 0px; width: 70%;">
          <input type="text" matInput [placeholder]="t('Remarks', 'Remarks')" formControlName="remarks">
        </mat-form-field>
        <img style="height:70px;width:70px"
          [src]="this.CloseImage ? this.CloseImage === '' ? 'assets/images/no-image.png' : this.CloseImage : 'assets/images/no-image.png'"
          (click)="imageZoom()" />
      </div>
    </form>
  </mat-dialog-content>
</ng-template>
<ng-template #imageZoomModel>

  <img [src]="currentImagePath ? currentImagePath : 'assets/images/no-image.png'"
    style="height: 98%; width: 100%; overflow: hidden;">

</ng-template>


<ng-template #ViewActionDetailModel>
  <div mat-dialog-title>
    <div class="d-flex justify-content-between align-items-center">
      <h2>{{ t('ActionDetail', 'Action Detail') }}</h2>
      <button mat-mini-fab mat-button mat-dialog-close color="warn" [title]="t('Close', 'Close')">
        <i class="fa fa-times" style="color: #fff"></i>
      </button>
    </div>
  </div>
  <mat-dialog-content>
    <!-- <div class="mat-elevation-z8"> -->
    <ag-grid-angular style="width: 100%; height: 30vw" class="ag-theme-alpine" [rowData]="rowDataViewActions"
      [columnDefs]="columnDefsActionView" [gridOptions]="actionGridOption" (cellClicked)="cellClickedAction($event)"
      [pagination]="true">
    </ag-grid-angular>
    <!-- </div> -->
  </mat-dialog-content>
</ng-template>

<ng-template #imageViewModal>
  <mat-carousel timings="250ms ease-in" [autoplay]="false" interval="5000" color="accent" [loop]="true"
    [hideArrows]="false" [hideIndicators]="false" [useKeyboard]="true" [useMouseWheel]="true" orientation="ltr">
    <mat-carousel-slide #matCarouselSlide *ngFor="let slide of slidesImages; let i = index" [image]="slide"
      overlayColor="#00000040" [hideOverlay]="false"></mat-carousel-slide>
  </mat-carousel>
</ng-template>